/** Get scrollbar width */
const getScrollbarWidth = (): number => {
  const scrollDiv = document.createElement('div');
  const divSize = '50px';
  let size = 0;

  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = `-${divSize}`;
  scrollDiv.style.width = divSize;
  scrollDiv.style.height = divSize;
  scrollDiv.style.overflow = 'scroll';

  document.body.appendChild(scrollDiv);
  size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);

  return size;
};

export default getScrollbarWidth;
